/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { PlainHashMap } from '../../../../../types'

export function undefineEmptyStrings(value: PlainHashMap) {
  for (const key of Object.keys(value)) {
    const property = value[key]

    if (property === '') {
      value[key] = undefined
    } else if (property != null && typeof property === 'object') {
      undefineEmptyStrings(property)
    }
  }
}
